import React, { Component } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

import Carroussel from './carroussel';
import SideBanner from './side-banner';

const Container = styled.div`
  background: #DEDEDE;
  padding-top: 40px;
  .wrapper{
    justify-content: space-between;
    @media (min-width: 1024px) {
      height: 500px;
    }
    @media (max-width: 1024px) {
      flex-wrap: wrap;
    }
    .column {
      display: flex;
      width: 100%;
      height: 100%;
      @media (min-width: 1024px) {
        align-content: space-between;
        flex-wrap: wrap;
        width: 30%;
      }
      @media (max-width: 1024px) {
        justify-content: space-between;
        flex-wrap: wrap;
        width: 100%;
      }
    }
  }
`;

class Banners extends Component {
  render = () => {
    const { banner_dir_inferior, banner_dir_topo, banner_principal } = this.props;
    return (
      <Container>
        <div className="wrapper flex">
          <Carroussel banners={ banner_principal } />
          <div className="column">
            <SideBanner {...banner_dir_topo} />
            <SideBanner {...banner_dir_inferior} />
          </div>
        </div>
      </Container>
    );
  }
}

Banners.propTypes = {
  dispatch: PropTypes.func,
  match: PropTypes.object,
  location: PropTypes.object,
};

export default Banners;
